
export const Statuses = {
    UnknownStatus: 0,
    StorageRequest: {
        Draft: 1,
        AwaitingApprovalOpen: 2,
        ApprovedOpen: 3,
        RejectedOpen: 4,
        RejectedClosed: 5,
        ApprovedClosed: 6
    }
}